module.exports = new __parcel__URL__("BTCLogo.5558c6c7.svg").toString();